import { useState, useEffect } from "react";
import { Post } from "../../../../Services/Server";
import Url from "../../../../Services/Url";
import { toast } from "react-toastify";
import css from "./Details.module.css";
import Head from "../../../../Components/Head/Head";
import Svg from "../../../../Components/Svg/Svg";
import SvgOptions from "../../../../Components/Svg/SvgOptions";
import ImgThumb from "../../../../Components/ImgThumb/ImgThumb";
import img from "../../../../Assets/Images/userImage.png";
import CertModal from "./CertModal";
import { ModalAction } from "../../../../Routes/NavRouter";

const parseJson = (data) => {
	if (!data) return [];
	try {
		return JSON.parse(data);
	} catch {
		return [];
	}
};

// Convert backend date format YYYYMMDD → YYYY-MM-DD
const formatDate = (raw) => {
	if (!raw || raw.length !== 8) return raw;
	return `${raw.substring(0, 4)}-${raw.substring(4, 6)}-${raw.substring(6, 8)}`;
};

const Left = ({ state, setState }) => {
	const { staffBiodata } = state;

	const [certs, setCerts] = useState(() =>
		parseJson(staffBiodata?.docId)?.map((id, idx) => ({
			id,
			status: parseJson(staffBiodata?.docStatus)[idx] || "Active",
			expirationDate: formatDate(
				parseJson(staffBiodata?.docExpirationDate)[idx]
			),
			name: parseJson(staffBiodata?.docName)[idx] || `Certificate ${idx + 1}`,
		}))
	);

	const [showCerts, setShowCerts] = useState(true);
	const [modalOpen, setModalOpen] = useState(false);
	const [editingCert, setEditingCert] = useState(null);
	const [previewCert, setPreviewCert] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		if (previewCert) setLoading(true);
	}, [previewCert]);

	const handleSaveCert = (payloadFromModal) => {
		const newCerts = payloadFromModal.docId.map((id, idx) => ({
			id,
			status: payloadFromModal.docStatus[idx] === 0 ? "Active" : "Inactive",
			expirationDate: formatDate(payloadFromModal.docExpirationDate[idx]),
			name: payloadFromModal.docName[idx] || `Certificate ${idx + 1}`,
		}));

		setCerts(newCerts);

		Post(Url.updateProfile, payloadFromModal).then((res) => {
			setState((prev) => ({
				...prev,
				staffBiodata: res?.data || {
					...prev.staffBiodata,
					...payloadFromModal,
				},
			}));
			toast.success("Certification saved");
		});

		setModalOpen(false);
		setEditingCert(null);
	};

	const handleDelete = (index) => {
		ModalAction.confirm({
			title: "Confirm Delete",
			text: "Are you sure you want to delete this certification?",
			exitText: "Exit",
			okText: "Delete",
			onOk: () => {
				const updatedCerts = certs.filter((_, i) => i !== index);
				setCerts(updatedCerts);

				const updatedStaff = {
					...staffBiodata,
					docId: updatedCerts.map((c) => c.id),
					docStatus: updatedCerts.map((c) => c.status),
					docExpirationDate: updatedCerts.map((c) => c.expirationDate),
					docName: updatedCerts.map((c) => c.name),
				};

				Post(Url.updateProfile, updatedStaff).then((res) => {
					setState((prev) => ({
						...prev,
						staffBiodata: res?.data || updatedStaff,
					}));
					toast.success("Certification deleted");
				});
			},
		});
	};

	const hasCerts =
		staffBiodata?.docId?.length ||
		staffBiodata?.docStatus?.length ||
		staffBiodata?.docName?.length;

	return (
		<div className={css.Left}>
			<Head
				title={staffBiodata.firstname + " " + staffBiodata.lastname}
				state={state}
			/>
			<div className={css.Main}>
				<div>
					<ImgThumb size={200}>{img}</ImgThumb>
				</div>
				<div className={css.About}>
					<h3>About</h3>
					<div>
						<div>Staff Number:</div>
						<div>{staffBiodata.staffNumber}</div>
					</div>
					<div>
						<div>First name:</div>
						<div>{staffBiodata.firstname}</div>
					</div>
					<div>
						<div>Last name:</div>
						<div>{staffBiodata.lastname}</div>
					</div>
					<div>
						<div>Role:</div>
						<div>{staffBiodata.appRoles.map((v) => v.name).join(", ")}</div>
					</div>
					<div>
						<div>Email:</div>
						<div>{staffBiodata.email}</div>
					</div>
					<div>
						<div>Designation:</div>
						<div>{staffBiodata.designation?.name}</div>
					</div>
				</div>
			</div>

			{/* Certifications Section */}

			{hasCerts ? (
				<div className={css.FormsContainer}>
					<>
						<div
							className={css.BoxTitle}
							onClick={() => setShowCerts((s) => !s)}
						>
							<Svg className={css.svg}>
								{!showCerts
									? SvgOptions.ArrowSideFill
									: SvgOptions.ArrowDownFill}
							</Svg>
							Certifications
						</div>

						{showCerts && (
							<div className={css.InputsContainer}>
								<table className={css.CertTable}>
									<thead>
										<tr>
											<th>Name</th>
											<th>Expiration Date</th>
											<th>Status</th>
											<th>Document</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
										{certs.map((cert, index) => {
											const isExpired =
												cert.expirationDate &&
												new Date(cert.expirationDate) < new Date();
											return (
												<tr
													key={index}
													className={isExpired ? css.ExpiredRow : ""}
												>
													<td>{cert.name}</td>
													<td>{cert.expirationDate || "-"}</td>
													<td>
														<div
															className={`${css.Status} ${
																isExpired ? css.StatusExpired : css.StatusActive
															}`}
														>
															<span className={css.StatusDot}></span>
															{isExpired ? "Expired" : "Active"}
														</div>
													</td>
													<td>
														{cert.id ? (
															<button
																className={css.ViewBtn}
																onClick={() => setPreviewCert(cert.id)}
															>
																View
															</button>
														) : (
															"-"
														)}
													</td>
													<td className={css.icons}>
														<Svg
															onClick={() => {
																setEditingCert(index);
																setModalOpen(true);
															}}
															className={css.ActionIcon}
														>
															{SvgOptions.Edit4}
														</Svg>
														<Svg
															onClick={() => handleDelete(index)}
															className={css.ActionIcon}
														>
															{SvgOptions.Delete}
														</Svg>
													</td>
												</tr>
											);
										})}
									</tbody>
								</table>

								<button
									className={css.UploadCertBtn}
									onClick={() => setModalOpen(true)}
								>
									<Svg className={css.svg}>{SvgOptions.Add}</Svg> Add New
									Certification
								</button>
							</div>
						)}
					</>
				</div>
			) : (
				// <div className={css.InputsContainer}>
				<button
					className={css.UploadCertBtn}
					onClick={() => setModalOpen(true)}
				>
					<Svg className={css.svg}>{SvgOptions.Add}</Svg> Upload Certification
				</button>
				// </div>
			)}

			{/* Modals */}
			{modalOpen && (
				<CertModal
					onClose={() => {
						setModalOpen(false);
						setEditingCert(null);
					}}
					onSave={handleSaveCert}
					existing={editingCert !== null ? certs[editingCert] : null}
					staffBiodata={staffBiodata}
					disablePastDates={true}
				/>
			)}

			{previewCert && (
				<div
					className={css.PreviewOverlay}
					onClick={() => setPreviewCert(null)}
				>
					<div
						className={css.PreviewContent}
						onClick={(e) => e.stopPropagation()}
					>
						<span
							className={css.CloseIcon}
							onClick={() => setPreviewCert(null)}
						>
							×
						</span>
						{loading && <div className={css.Loader}>Loading...</div>}
						{Url.img.get(previewCert).toLowerCase().endsWith(".pdf") ? (
							<iframe
								src={Url.img.get(previewCert)}
								title="Certificate Preview"
								onLoad={() => setLoading(false)}
							/>
						) : (
							<img
								src={Url.img.get(previewCert)}
								alt="Certificate"
								onLoad={() => setLoading(false)}
							/>
						)}
					</div>
				</div>
			)}
		</div>
	);
};

export default Left;
